import addValidationMessage from '../utils/translation/addValidationMessage';
import requiredValidator from './requiredValidator';

addValidationMessage('Core/phoneValidator', 'phone', {
  fr: 'Le téléphone n\'est pas valide',
  en: 'The phone number is not valid',
});

const phoneValidator = (value: string) => {
  if (!requiredValidator(value)) {
    return true;
  }

  const cleanedValue = String(value).replace(/[^0-9]/g, '');

  return cleanedValue.length === 10;
};

/**
 * @component
 * @visibleName phoneValidator
 */
export default phoneValidator;
